"use client"

import { formatDateSimpleYyyyMmDd, generateImagePath } from "@/lib/utils"
import { PostData } from "@/types/types"
import Image from "next/image"

import PostLink from "@/components/PostLink"
import { DefaultImage } from "@/lib/external-components"
import type { Article } from "../../../tamda-media/TamdaMediaNewsLayout/types/new"

interface NewsCardProps {
  article: Article
  postData?: PostData
  className?: string
  locale?: string
}

export function NewsCard({ article, postData, className = "" }: NewsCardProps) {
  const { title, slug, imageUrl, publishedAt, formats } = article

  const formatSrc = imageUrl ? generateImagePath(imageUrl, "small", formats) : DefaultImage

  const firstCategoryName = postData?.attributes?.categories?.data?.[0]?.attributes?.name || ""

  const postId = postData?.id
  const currentViews = postData?.attributes?.views

  // Locale của chính bài; PostLink tự prefix as-needed.
  const postLocale = postData?.attributes?.locale
  return (
    <PostLink
      href={`/${slug}`}
      locale={postLocale}
      postId={postId}
      className={`flex flex-col gap-[17px] group image-hover overflow-hidden sm:w-[370px] ${className}`}
    >
      <div className="w-full h-[281.19px] overflow-hidden rounded-[5px]">

        {imageUrl && (<Image
          src={formatSrc}
          alt={title}
          className="object-cover w-full h-full hover:scale-105 transition-transform duration-300 group-hover:rounded-[5px] rounded-[5px]"
          width={300}
          height={200}
        />)}

      </div>

      <div className="flex flex-col sm:gap-[15px] gap-[5] pl-[5px]">
        {firstCategoryName && (
          <span className="text-xs leading-[14px] font-bold text-[#18af4e] uppercase">
            {firstCategoryName}
          </span>
        )}

        <h3 className="text-base leading-[19px] font-bold text-black uppercase sm:pb-0 pb-[5px]">
          {title}
        </h3>

        <p className="sm:text-base sm:leading-[19px] text-[12px] leading-[14px] sm:font-normal font-medium text-[#242f3e] opacity-70">
          {formatDateSimpleYyyyMmDd(publishedAt)}
        </p>
      </div>
    </PostLink>
  )
}
